import { DecimalPipe, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { ForecastDateKpi } from 'demand-forecasting/types/forecast-chart/forecast-date-kpi.interface';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
  selector: 'pm-forecast-prediction-kpis',
  templateUrl: './forecast-prediction-kpis.component.html',
  styleUrls: ['./forecast-prediction-kpis.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    InlineSVGModule,
    NgStyle,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    TranslateModule,
    DecimalPipe,
  ],
})
export class ForecastPredictionKpisComponent {
  @Input({
    required: true,
  })
  forecastDateKpis: ForecastDateKpi[] = [];
}
